<template>
  <div v-if="!isLoading">
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="500"
        rounded
        id="japu-dialog"
        width="500"
      >
        <v-card class="pa-2">
          <v-col cols="12" class="text-left pa-0 ma-0">
            <v-btn
              dark
              text
              @click="closeDialogGtm"
              color="primary"
              x-small
              class="pl-0"
            >
              <v-icon dark class="font-weight-medium">mdi-close</v-icon>
            </v-btn>
          </v-col>

          <v-card-title class="justify-center pb-0 pt-1 px-1">
            <div class="text-center display-24 font-weight-medium">
              {{ JAPUProperties.JAPUHeader }}
            </div>
          </v-card-title>

          <v-card-text
            class="justify-center text-center pb-2 px-1 display-18 black--text"
          >
            <span v-html="JAPUProperties.SubHeader" class=""></span>
            <v-divider class="mt-2 divider"></v-divider>
          </v-card-text>

          <v-card-text v-if="!$auth.loggedIn" class="">
            <!-- loggedOut/new users -->
            <JapuForm @closeJapu="closeJapu" :JAPUProperties="JAPUProperties" />
          </v-card-text>
          <v-card-text v-if="$auth.loggedIn" class="">
            <!-- loggedIn users -->
            <v-form
              ref="japuFormSign"
              v-model="valid"
              :disabled="loading"
              class="text-center"
            >
              <v-btn
                dense
                rounded
                color="primary"
                class="mx-auto px-5 my-4"
                :loading="loading"
                @click="japuRregisteredUser"
              >
                יצירת סוכן חכם
              </v-btn>
            </v-form>
          </v-card-text>
          <small v-if="error" class="d-block text-center py-2 error-message">
            {{ errorMessgae }}
          </small>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import JapuForm from '@/components/Forms/JapuForm.vue';
import { REGISTER_SMART_ALERTS } from '@/lib/api.js';
import gtm from '@/lib/gtm';
import errors from '@/lib/errorsList';
import CurrentUser from '@/components/mixins/CurrentUser';

export default {
  name: 'JapuSearchDialog',
  mixins: [CurrentUser],
  components: {
    JapuForm,
  },
  props: {
    showJapu: {
      type: Boolean,
      default: false,
      required: false,
    },
    JAPUProperties: {
      type: Object,
      required: false,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      dialog: true,
      valid: true,
      loading: false,
      error: false,
      errorMessgae: null,
      userLogin: this.$auth.loggedIn,
    };
  },
  methods: {
    async japuRregisteredUser() {
      gtm({
        interaction: 'click',
        event: 'japu',
      });
      try {
        if (this.$refs.japuFormSign.validate()) {
          this.loading = true;

          const data = {
            Categories: this.JAPUProperties.Categories,
            Locations: this.JAPUProperties.Locations,
            Keywords: this.JAPUProperties.Keywords,
          };

          const response = await this.$axios.post(REGISTER_SMART_ALERTS, data);

          if (response.data.IsError) {
            throw response.data.ErrorsMessages;
          }

          // gtm({
          //   email: this.CurrentUser.Email,
          //   phone: this.CurrentUser.Profile.Phone || '',
          //   event: 'smart_agent_gads',
          // });

          this.closeJapu();
        }
      } catch (error) {
        this.submitError(error);
        console.log(error);
      }
    },
    submitError(err) {
      this.errorMessgae = errors[Object.keys(err)[0]];
      this.error = true;
      this.loading = false;
    },
    closeJapu() {
      this.dialog = false;
      this.loading = false;
    },
    closeDialogGtm() {
      gtm({
        interaction: 'click_close',
        event: 'japu',
      });
      this.dialog = false;
    },
  },

  watch: {
    showJapu() {
      this.dialog = true;
    },
  },
};
</script>
<style lang="scss">
#japu-dialog {
  border-radius: 20px;
}
.v-divider.divider {
  border-width: 5px;
  border-width: 1px;
  border-color: #f6f7f9;
  max-width: 80%;
  margin: 0 auto;
}
</style>